import React, { useState, useEffect } from "react";
import api, { withCompanyId } from "../../Components/API/Api";
import classes from './UploadBasicSalary.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation } from 'react-router-dom';
import { Eye, Edit, Trash } from 'lucide-react';
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import mail from "../../Assets/mail.png";
import call from "../../Assets/call.png";
import Footer from "../../Components/Footer/Footer";
import { Pen, Trash2, Printer } from "lucide-react";
import { useNavigate } from "react-router-dom";
import UploadSalaryModal from "../../Components/Modals/UploadSalaryModal";
import CreateEmployeeSalaryModal from "../../Components/Modals/CreateEmployeeSalaryModal";
import Swal from "sweetalert2";

// Modal styles
const modalOverlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
};

const modalContentStyle = {
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "2rem",
    maxWidth: "500px",
    width: "90%",
    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.15)",
};

const modalHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1.5rem",
    fontSize: "1.25rem",
    fontWeight: 600,
    color: "#333",
};

const closeBtnStyle = {
    background: "none",
    border: "none",
    fontSize: "2rem",
    cursor: "pointer",
    color: "#666",
    padding: 0,
    width: "32px",
    height: "32px",
};

const formGroupStyle = {
    marginBottom: "1.5rem",
};

const inputStyle = {
    width: "100%",
    padding: "0.75rem",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontSize: "1rem",
    boxSizing: "border-box",
};

const disabledInputStyle = {
    ...inputStyle,
    backgroundColor: "#f5f5f5",
    color: "#999",
    cursor: "not-allowed",
};

const modalActionsStyle = {
    display: "flex",
    gap: "1rem",
    justifyContent: "flex-end",
    marginTop: "2rem",
};

const cancelBtnStyle = {
    padding: "0.75rem 1.5rem",
    border: "none",
    borderRadius: "4px",
    fontSize: "1rem",
    fontWeight: 500,
    cursor: "pointer",
    backgroundColor: "#f5f5f5",
    color: "#333",
    transition: "all 0.3s ease",
};

const submitBtnStyle = {
    padding: "0.75rem 1.5rem",
    border: "none",
    borderRadius: "4px",
    fontSize: "1rem",
    fontWeight: 500,
    cursor: "pointer",
    backgroundColor: "#16a34a",
    color: "white",
    transition: "all 0.3s ease",
};

const UploadBasicSalary = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingEmployee, setEditingEmployee] = useState(null);
    const [editFormData, setEditFormData] = useState({
        basic_salary: ""
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        const fetchEmployeeSalaries = async () => {
            try {
                const companyId = localStorage.getItem('company_id') || '';
                const response = await api.get(`/v1/payroll/salary_structure/fetch_employee_direct_salary?company_id=${companyId}`);
                const result = Array.isArray(response.data?.data) ? response.data.data : Array.isArray(response.data) ? response.data : [];
                setData(result);
            } catch (error) {
                setData([]);
                console.error("Error fetching employee salaries:", error);
            }
        };

        fetchEmployeeSalaries();
    }, []);

    const refreshEmployeeSalaries = async () => {
        try {
            const companyId = localStorage.getItem('company_id') || '';
            const response = await api.get(`/v1/payroll/salary_structure/fetch_employee_direct_salary?company_id=${companyId}`);
            const result = Array.isArray(response.data?.data) ? response.data.data : Array.isArray(response.data) ? response.data : [];
            setData(result);
        } catch (error) {
            console.error("Error fetching employee salaries:", error);
        }
    };

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    const handleEditClick = (employee) => {
        setEditingEmployee(employee);
        setEditFormData({
            basic_salary: employee.basic_salary || ""
        });
        setShowEditModal(true);
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleDeleteClick = async (employee) => {
        const confirmDelete = await Swal.fire({
            icon: "warning",
            title: "Delete Employee Salary",
            text: `Are you sure you want to delete the salary record for ${employee.employee_name}?`,
            showCancelButton: true,
            confirmButtonColor: "#dc2626",
            cancelButtonColor: "#6b7280",
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel",
        });

        if (!confirmDelete.isConfirmed) return;

        try {
            const response = await api.get(
                `/v1/payroll/salary_structure/delete_employee_direct_salary?id=${employee.id}&company_id=${localStorage.getItem('company_id') || ''}`
            );

            if (response?.data?.status === true || response?.data?.success === true) {
                await Swal.fire({
                    icon: "success",
                    title: "Deleted",
                    text: response?.data?.message || "Employee salary record deleted successfully",
                    confirmButtonColor: "#16a34a",
                });

                // Refresh the data
                const companyId = localStorage.getItem('company_id') || '';
                const fetchResponse = await api.get(`/v1/payroll/salary_structure/fetch_employee_direct_salary?company_id=${companyId}`);
                const result = Array.isArray(fetchResponse.data?.data) ? fetchResponse.data.data : Array.isArray(fetchResponse.data) ? fetchResponse.data : [];
                setData(result);
            } else {
                await Swal.fire({
                    icon: "error",
                    title: "Delete failed",
                    text: response?.data?.message || "Could not delete employee salary",
                    confirmButtonColor: "#16a34a",
                });
            }
        } catch (error) {
            await Swal.fire({
                icon: "error",
                title: "Server Error",
                text: error?.response?.data?.message || "Something went wrong. Please try again.",
                confirmButtonColor: "#16a34a",
            });
        }
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        if (!editingEmployee) return;
        
        setIsSubmitting(true);
        try {
            const payload = {
                id: editingEmployee.id,
                employee_id: editingEmployee.employee_id,
                employee_name: editingEmployee.employee_name,
                basic_salary: editFormData.basic_salary,
                ...withCompanyId({})
            };
            
            const response = await api.post(
                "/v1/payroll/salary_structure/update_employee_direct_salary",
                payload
            );

            if (response?.data?.status === true || response?.data?.success === true) {
                await Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: response?.data?.message || "Employee salary updated successfully",
                    confirmButtonColor: "#16a34a",
                });
                
                // Refresh the data
                const companyId = localStorage.getItem('company_id') || '';
                const fetchResponse = await api.get(`/v1/payroll/salary_structure/fetch_employee_direct_salary?company_id=${companyId}`);
                const result = Array.isArray(fetchResponse.data?.data) ? fetchResponse.data.data : Array.isArray(fetchResponse.data) ? fetchResponse.data : [];
                setData(result);
                
                setShowEditModal(false);
                setEditingEmployee(null);
            } else {
                await Swal.fire({
                    icon: "error",
                    title: "Update failed",
                    text: response?.data?.message || "Could not update employee salary",
                    confirmButtonColor: "#16a34a",
                });
            }
        } catch (error) {
            await Swal.fire({
                icon: "error",
                title: "Server Error",
                text: error?.response?.data?.message || "Something went wrong. Please try again.",
                confirmButtonColor: "#16a34a",
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />
            <div className={classes.Container}>
                {/* <div className={classes.actions}>
                    <button
                        className={classes.btns}
                        onClick={() => navigate("/transactions/sales-invoice/sale")}
                    >
                        Sales Invoice
                    </button>
                    <button className={classes.btns} onClick={() => navigate("/inventory/purchaseOrder")}> Purchase Order</button>
                    <button
                        className={classes.btns}
                        style={{ backgroundColor: '#16A34A', color: 'white' }}
                    >
                        Upload Basic Salary
                    </button>
                    <button onClick={() => navigate('/settings/product-services')} className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
                </div> */}

                <header className={classes.Header}>
                    <div>
                        <h2 className={classes.Title}>Upload Basic Salary</h2>
                        <h1 className={classes.Titles}>
                            Manage your employee basic salary, update, and remove non existent ones.
                        </h1>
                    </div>


                    {/* <div className={classes.thrdkad}>
                        <div className={classes.kad}>
                            <p className={classes.kdptg}>Total Outstanding</p>
                            <p className={classes.kdptg1}>₦8,400,000.00</p>
                            <div className={classes.rvnue}>
                                <p className={classes.skaltxt}>All Basic Salary</p>
                            </div>
                        </div>
                    </div> */}
                </header>

                <div className={classes.entrjj}>
                    <div className={classes.allkads}>

                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Current(0-30 days)</p>
                                <p className={classes.kdptg2}>₦4,950,000.00</p>
                                {/* <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Not yet due</p>
                                </div> */}
                            </div>
                        </div>
                        <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>1-30 days Overdue</p>
                                <p className={classes.kdptg3}>₦3,200,000.00</p>
                                {/* <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Recently Overdue</p>
                                </div> */}
                            </div>
                        </div>
                        <div className={classes.frstkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>31-60 Days Overdue</p>
                                <p className={classes.kdptg4}>15</p>
                                {/* <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Moderate Risk</p>
                                </div> */}
                            </div>
                        </div>

                        <div className={classes.secondkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>60+ Days Overdue</p>
                                <p className={classes.kdptg4}>15</p>
                                {/* <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>High Risk</p>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>

                <div className={classes.headerActions}>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                            <input type="text" className={classes.searchBar} placeholder="Search sales" />
                        </div>


                        <div className={classes.selectWrapper}>
                            <select className={classes.dropdown}>
                                <option value="">All Methods</option>
                                <option value="Paid">Paid</option>
                                <option value="Pending">Pending</option>
                                <option value="Overdue">Overdue</option>
                                <option value="Draft">Draft</option>
                            </select>
                            <span className={classes.dropdownArrow}>▼</span>
                        </div>

                        <div className={classes.inputWrapper}>
                            <input type="text" className={classes.searchBars} placeholder="Filter..." />
                            <img src={filter} alt="Filter" className={classes.inputIcon} />
                        </div>
                    </div>
                    <div className={classes.btnsMain}>
                        {/* <button className={classes.btnssWhite}> <img src={mail} alt="" /> Send Reminder</button>*/}
                        <button className={classes.btnss} onClick={() => setShowCreateModal(true)}> + Employee Basic Salary</button>
                        <button className={classes.btnss} onClick={() => setShowUploadModal(true)}> + New Basic Salary</button>
                    </div>

                </div>

                <div className={classes.tableContainer}>
                    <table className={classes.table}>
                        <thead>
                            <tr className={classes.tableHeader}>
                                <th>Employee ID</th>
                                <th>Employee Name</th>
                                <th style={{ width: "140px" }}>Basic Salary</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(Array.isArray(data) ? data : []).map((row, index) => (
                                <tr key={index} className={classes.tableRow}>
                                    <td className={classes.tableCell}>{row.employee_id}</td>
                                    <td className={classes.tableCell}>{row.employee_name}</td>
                                    <td className={classes.tableCell3} style={{ width: "140px" }}>
                                        {new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(Number(row.basic_salary))}
                                    </td>
                                    <td className={classes.actions}>
                                        <Pen size={16} className={classes.editIcon} onClick={() => handleEditClick(row)} style={{ cursor: "pointer" }} />
                                        <Trash2 size={16} className={classes.deleteIcon} onClick={() => handleDeleteClick(row)} style={{ cursor: "pointer" }} />
                                        {/* <Printer size={16} className={classes.printIcon} onClick={() => handlePrint(item)}
                                                                style={{ cursor: "pointer" }} /> */}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <table className={classes.footerTable}>
                    <tfoot>
                        <tr>
                            <td>First</td>
                            <td className={`${classes.page} ${classes.activePage}`}>1</td>
                            <td className={classes.page}>2</td>
                            <td>Last</td>
                        </tr>
                        <div className={classes.paginationDisplay}>Displaying 1 - 25 of 41</div>

                    </tfoot>

                </table>
            </div>
            <UploadSalaryModal 
                isOpen={showUploadModal} 
                onClose={() => setShowUploadModal(false)} 
            />
            
            <CreateEmployeeSalaryModal 
                isOpen={showCreateModal} 
                onClose={() => setShowCreateModal(false)} 
                onSuccess={refreshEmployeeSalaries}
            />
            
            {/* Edit Employee Modal */}
            {showEditModal && editingEmployee && (
                <div style={modalOverlayStyle} onClick={() => setShowEditModal(false)}>
                    <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
                        <div style={modalHeaderStyle}>
                            <h2 style={{ margin: 0, fontSize: "1.25rem" }}>Edit Employee Salary</h2>
                            <button 
                                style={closeBtnStyle}
                                onClick={() => setShowEditModal(false)}
                            >
                                ×
                            </button>
                        </div>
                        <form onSubmit={handleEditSubmit}>
                            <div style={formGroupStyle}>
                                <label>Employee ID</label>
                                <input 
                                    type="text" 
                                    value={editingEmployee.employee_id} 
                                    disabled 
                                    style={disabledInputStyle}
                                />
                            </div>
                            <div style={formGroupStyle}>
                                <label>Employee Name</label>
                                <input 
                                    type="text" 
                                    value={editingEmployee.employee_name} 
                                    disabled 
                                    style={disabledInputStyle}
                                />
                            </div>
                            <div style={formGroupStyle}>
                                <label htmlFor="basic_salary">Basic Salary *</label>
                                <input 
                                    type="number" 
                                    id="basic_salary"
                                    name="basic_salary" 
                                    value={editFormData.basic_salary}
                                    onChange={handleEditChange}
                                    placeholder="Enter basic salary"
                                    required
                                    min="0"
                                    style={inputStyle}
                                />
                            </div>
                            <div style={modalActionsStyle}>
                                <button 
                                    type="button" 
                                    style={cancelBtnStyle}
                                    onClick={() => setShowEditModal(false)}
                                    disabled={isSubmitting}
                                >
                                    Cancel
                                </button>
                                <button 
                                    type="submit" 
                                    style={{...submitBtnStyle, opacity: isSubmitting ? 0.6 : 1}}
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Processing..." : "Update Salary"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            
            <Footer />
        </div>
    );
};

// export default Receivables;
//                 <table className={classes.footerTable}>
//                     <tfoot>
//                         <tr>
//                             <td>First</td>
//                             <td className={`${classes.page} ${classes.activePage}`}>1</td>
//                             <td className={classes.page}>2</td>
//                             <td>Last</td>
//                         </tr>
//                         <div className={classes.paginationDisplay}>Displaying 1 - 25 of 41</div>

//                     </tfoot>

//                 </table>
//             </div>
//             <Footer />

//         </div>
//     );
// };

export default UploadBasicSalary;
